export default __webpack_public_path__ + "static/media/9a8ad28566debd506d1aa19ff189fbee.svg";